import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import HandshakeImage from "../../Images/(handshake)-Investment_Pg.webp";
import KsaBackground from "../../Images/KsaBackground.webp";

// Number Counter Hook
const useCounter = (target, duration) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = parseInt(target.replace(/[^\d]/g, ""));

    if (start === end) return;

    const totalMs = duration;
    const incrementTime = 30;
    const steps = Math.ceil(totalMs / incrementTime);
    const increment = end / steps;

    const counter = setInterval(() => {
      start += increment;
      if (start >= end) {
        clearInterval(counter);
        setCount(end);
      } else {
        setCount(Math.ceil(start));
      }
    }, incrementTime);

    return () => clearInterval(counter);
  }, [target, duration]);

  let suffix = "";
  if (target.includes("%")) suffix = "%";
  else if (target.includes("M")) suffix = "M+";
  else if (target.includes("K")) suffix = "K+";
  else if (target.includes("+")) suffix = "+";

  return `${count}${suffix}`;
};

const PartnershipSection = () => {
  const navigate = useNavigate();
  const customerSatisfaction = useCounter("99%", 1000);
  const investedCapital = useCounter("50M+", 1300);
  const successfulDeals = useCounter("2600+", 1600);

  return (
    <section className="bg-black">
      {/* Take a Look at Our Numbers */}
      <div
        className="relative text-white py-12 px-6 bg-cover bg-[position:30%]"
        style={{
          backgroundImage: `url(${KsaBackground})`,
        }}
      >
        <div className="absolute" />
        <div
          className="relative z-10 max-w-8xl mx-auto flex flex-col md:flex-row justify-between items-start"
          data-aos="fade-up"
        >
          {/* Left-aligned heading and description */}
          <div className="max-w-2xl md:pr-12 mb-10 md:mb-0">
            <h2 className="text-2xl md:text-4xl font-semibold mb-4">
              Take a look at our numbers
            </h2>
            <p className="text-gray-300 text-md md:text-lg">
              Our track record reflects successful partnerships, foreign
              investments, and impactful market expansion across Saudi Arabia.
            </p>
          </div>

          {/* Right-aligned animated stats */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-10 text-right w-full md:w-auto my-auto">
            <div className="mx-auto md:mx-0">
              <h3 className="text-4xl font-extrabold text-white drop-shadow-md text-center">
                {customerSatisfaction}
              </h3>
              <p className="text-gray-200 text-[14px]">Customer satisfaction</p>
            </div>
            <div className="mx-auto md:mx-0">
              <h3 className="text-4xl font-extrabold text-white drop-shadow-md">
                {investedCapital}
              </h3>
              <p className="text-gray-200 text-[14px]">Invested capital</p>
            </div>
            <div className="mx-auto md:mx-0">
              <h3 className="text-4xl font-extrabold text-white drop-shadow-md">
                {successfulDeals}
              </h3>
              <p className="text-gray-200 text-[14px]">Successful deals</p>
            </div>
          </div>
        </div>
      </div>

      {/* Partnership Opportunities Section */}
      <div
        className="relative bg-[#caa957] py-16 px-1 md:px-0 overflow-hidden"
        data-aos="fade-up"
      >
        <div className="relative z-10 max-w-4xl mx-auto text-center text-white ">
          <h2 className="text-3xl md:text-5xl font-bold mb-6">
            Partnership Opportunities
          </h2>
          <div className="flex justify-center flex-col items-center">
            <p className="text-lg md:text-xl mb-6 max-w-2xl">
              We facilitate joint ventures, partnerships, and direct investment
              opportunities, ensuring that you are connected to the best local
              partners and markets
            </p>

            <p className="text-md md:text-lg mb-8 max-w-sm">
              to explore how we can help you invest in{" "}
              <span className="font-bold">Saudi Arabia’s future</span>
            </p>
          </div>
          <button 
            onClick={() => navigate('/ppp-partnerships')}
            className="bg-[#FFFFFF] text-[#C99C48] px-8 py-3 rounded-2xl text-lg font-semibold hover:bg-[#FFFFFF] transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            Learn More
          </button>
        </div>

        {/* Handshake Image */}
        <div className="relative flex justify-center">
          <img
            src={HandshakeImage}
            alt="Handshake"
            className="w-full max-w-9xl h-auto object-cover mt-0 md:mt-[-200px]"
          />
        </div>
      </div>
    </section>
  );
};

export default PartnershipSection;
